<tui-loader class="chart-loader" [showLoader]="isLoading" [overlay]="isLoading">
  <div
    echarts
    [options]="options"
    (chartInit)="onChartInit($event)"
    class="messages-chart"
    [style.height.px]="windowHeight - topValue - 40"
  ></div>
</tui-loader>
